import { render, staticRenderFns } from "./bannerZhuanqu.vue?vue&type=template&id=fcef66c8&"
import script from "./bannerZhuanqu.vue?vue&type=script&lang=js&"
export * from "./bannerZhuanqu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports